// src/api/leave.api.ts
import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const applyLeaveApi = async (payload: any) => {
  try {
    const res = await axiosSetup.post("/leave/apply", payload);
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const grantCompOffApi = async (payload: any) => {
  try {
    const res = await axiosSetup.post("/leave/comp-off-grant-apply", payload);
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLeaveBalanceApi = async () => {
  try {
    const res = await axiosSetup.get("/leave/balance");
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchManagersApi = async () => {
  try {
    const res = await axiosSetup.get("/leave/managers");
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAllLeaveApplicationsApi = async () => {
  try {
    const res = await axiosSetup.get("/leave/all-leave-application-data");
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const withdrawLeaveApi = async (applicationId: string) => {
  try {
    const res = await axiosSetup.post("/leave/withdraw", { applicationId });
    return res.data.data;
  } catch (err) {
    throw err;
  }
};

export const fetchManagerPendingApplicationsApi = async () => {
  try {
    const res = await axiosSetup.get(
      "/leave/manager/AllUserPendingApplications"
    );
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const approveOrRejectLeaveStatusApi = async ({
  applicationId,
  action,
}: {
  applicationId: string;
  action: "approved" | "rejected";
}) => {
  const res = await axiosSetup.post(`/leave/manager/approve-reject`, {
    applicationId,
    action,
  });
  return res.data.data;
};

export const cancelLeaveApi  = async (applicationId: string) => {
  try {
    const res = await axiosSetup.post("/leave/apply/leave-cancel", { applicationId });
    return res.data.data;
  } catch (err) {
    throw err;
  }
};

export const approveOrRejectCancelLeaveApplicationApi = async ({
  applicationId,
  action,
}: {
  applicationId: string;
  action: "approved" | "rejected";
}) => {
  const response = await axiosSetup.put(`/leave/manager/leave-cancel/approve-reject`, {
    applicationId,
    action,
  });
  return response.data.data;
};

export const fetchUserLeaveBalanceApi = async (userId: string) => {
  try {
    const res = await axiosSetup.get(`/leave/user-balance`, {
      params: { userId },
    });
    return res.data.data;
  } catch (error) {
    throw error;
  }
};
